import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { OwnerService } from '../../core/services/owner.service';
import { MemberService } from '../../core/services/member.service';
import { FlashService } from '../../core/services/flash.service';

@Component({
    selector: 'app-owner-new',
    imports: [RouterLink, FormsModule],
    template: `
<div class="animated fadeIn" >
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;新規作成</span>
        </div>
        <div class="card-body">
          <div style="height: 1px"></div>
            <form novalidate name="ownerBaseEditForm" #ownerBaseEditForm="ngForm">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">企業名</label>
                      <input type="text" class="form-control" [(ngModel)]="form.name" name="name" required>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">適格請求書発行事業者登録番号</label>
                      <div class="d-flex" style="column-gap: 0.5rem;">
                        <span style="margin: auto; font-size: 1.2rem;">T</span>
                        <input type="text" class="form-control" [(ngModel)]="form.invoiceRegistrationNumber" name="invoiceRegistrationNumber" required pattern="^[0-9]{13}$">
                      </div>
                    </div>
                  </div>
                  <div class="row" style="align-items: flex-end;">
                    <div class="form-group col-md-6">
                      <label class="col-form-label">郵便番号</label>
                      <div class="bisected-input-wrap">
                        <div class="bisected-input">
                          <input type="text" class="form-control" [(ngModel)]="form.zip1" name="zip1" required [pattern]="asciiPattern">
                        </div>
                        <span>&nbsp;</span>
                        <div class="bisected-input">
                          <input type="text" class="form-control" [(ngModel)]="form.zip2" name="zip2" required [pattern]="asciiPattern">
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <button type="button" class="btn btn-primary text-white" (click)="searchZipCode()"><i class="fa s-icon-autoAddress"></i>&nbsp;住所自動入力</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">住所</label>
                      <div class="quartered-input-wrap">
                        <div class="quartered-input">
                          <input type="text" class="form-control" [(ngModel)]="form.province" name="province" required>
                        </div>
                        <span>&nbsp;</span>
                        <div class="quartered-input">
                          <input type="text" class="form-control" [(ngModel)]="form.city" name="city" required>
                        </div>
                        <span>&nbsp;</span>
                        <div class="quartered-input">
                          <input type="text" class="form-control" [(ngModel)]="form.area" name="area" required>
                        </div>
                        <span>&nbsp;</span>
                        <div class="quartered-input">
                          <input type="text" class="form-control" [(ngModel)]="form.address" name="address">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">電話番号</label>
                      <div class="trisection-input-wrap">
                        <div class="trisection-input">
                          <input type="text" class="form-control" [(ngModel)]="form.phone1" name="phone1" required [pattern]="asciiPattern">
                        </div>
                        <span>&nbsp;</span>
                        <div class="trisection-input">
                          <input type="text" class="form-control" [(ngModel)]="form.phone2" name="phone2" required [pattern]="asciiPattern">
                        </div>
                        <span>&nbsp;</span>
                        <div class="trisection-input">
                          <input type="text" class="form-control" [(ngModel)]="form.phone3" name="phone3" required [pattern]="asciiPattern">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-8">
                      <label class="col-form-label">メールアドレス</label>
                      <input type="email" class="form-control" [(ngModel)]="form.email" name="email" email [pattern]="asciiPattern">
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="row">
              <div class="col-md-12 text-right">
                <a routerLink="/owner" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
                <button type="button" (click)="save(ownerBaseEditForm)" class="btn btn-success" [disabled]="saving || ownerBaseEditForm.invalid"><i class="fa s-icon-save"></i>&nbsp;保存</button>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class OwnerNewComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private ownerService = inject(OwnerService);
  private memberService = inject(MemberService);
  private router = inject(Router);
  private flash = inject(FlashService);

  form: any = {};
  saving = false;
  readonly asciiPattern = '^[\\x01-\\x7E]+$';

  ngOnInit(): void {
    this.pageTitleService.set('マスター管理/企業マスター', 's-icon-master');
  }

  async searchZipCode(): Promise<void> {
    const zipCode = `${this.form.zip1 ?? ''}-${this.form.zip2 ?? ''}`;
    if (!zipCode || zipCode === '-') return;
    const address: any = await this.memberService.getAddress(zipCode);
    if (!address) return;
    this.form.province = address.address1;
    this.form.city = address.address2;
    this.form.area = address.address3;
    this.form.address = '';
  }

  async save(form?: NgForm): Promise<void> {
    if (form?.invalid) {
      form.control.markAllAsTouched();
      return;
    }
    this.saving = true;
    try {
      const payload = {
        ...this.form,
        status: 1,
        restrictIp: 0,
        zip: `${this.form.zip1}-${this.form.zip2}`,
        phone: `${this.form.phone1}-${this.form.phone2}-${this.form.phone3}`,
      };
      delete payload.zip1;
      delete payload.zip2;
      delete payload.phone1;
      delete payload.phone2;
      delete payload.phone3;
      const saved: any = await this.ownerService.upsert(payload);
      const ownerId = saved?.id ?? saved?.result?.id;
      if (ownerId) {
        // 旧版 owner.js:119-121: Flash 後に編集画面へ遷移（表示は owner-edit の <flash-message>）
        this.flash.create('success', '企業を新規作成しました');
        await this.router.navigate(['/owner/edit', ownerId]);
      }
    } finally {
      this.saving = false;
    }
  }
}
